import Api from "./Api";

const endpoint = "/notenverwaltung/transactions";
export default {
    get(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        usedParams.show = params.show;

        return Api.fetchData(endpoint, usedParams);
    },
    getDuring(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        usedParams.show = params.show;

        return Api.fetchData(endpoint + "/during", usedParams);
    },
    getBilling(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        usedParams.show = params.show;

        return Api.fetchData(endpoint + "/billing", usedParams);
    }
};
